import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Colors } from "../../config";

const Dropdown = ({
  required = true,
  children,
  label = "",
  placeholder,
  prefixImg,
  width = "100%",
  value,
  topOffset = 0,
  position = "right",
  error,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeDropdown = () => {
    setOpen(false);
  };

  return (
    <DropdownContainer ref={dropdownRef}>
      <Label>
        {label} {required && <Required>*</Required>}
      </Label>
      <DropdownInputWrapper onClick={() => setOpen(!open)}>
        {prefixImg && <PrefixImg src={prefixImg} alt="dropdown icon" />}
        <DropdownInput
          value={value}
          placeholder={placeholder}
          readOnly
          disabled={disabled}
          error={error}
        />
        {!disabled && (
          <ArrowIcon
            src={require("../../assets/images/down-arrow.png")}
            alt="dropdown icon"
            open={open}
          />
        )}
      </DropdownInputWrapper>
      {error && <Error>{error}</Error>}
      {open && (
        <DropdownMenu width={width} topOffset={topOffset} position={position}>
          {React.cloneElement(children, { closeDropdown })}
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};

export default Dropdown;

const DropdownContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  width: 100%;
`;

const Label = styled.div`
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
`;

const Required = styled.span`
  color: red;
`;

const DropdownInputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  cursor: pointer;
`;

const PrefixImg = styled.img`
  width: 16px;
  position: absolute;
  left: 8px;
  top: 12px;
`;

const DropdownInput = styled.input`
  width: 100%;
  padding: 0.9rem;
  box-sizing: border-box;
  outline: none;
  border-radius: 32px;
  border: ${(props) =>
    props.error
      ? "1px solid rgb(182, 31, 19)"
      : "1px solid rgb(142, 142, 161)"};
  padding-left: ${(props) => (props.prefixImg ? "2rem" : "0.75rem")};
  font-size: 0.9rem;
  cursor: pointer;
  background-color: ${(props) => (props.disabled ? "#f0f0f0" : "white")};
  &:disabled {
    cursor: not-allowed;
  }
`;

const ArrowIcon = styled.img`
  width: 12px;
  position: absolute;
  right: 16px;
  top: 20px;
  transform: ${(props) => (props.open ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease-in-out;
`;

export const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.25rem;
  margin-left: 0.75rem;
`;

const DropdownMenu = styled.div`
  position: absolute;
  width: ${(props) => props.width};
  z-index: 99;
  right: ${(props) => (props.position === "right" ? 0 : "unset")};
  left: ${(props) => (props.position === "left" ? 0 : "unset")};
  top: ${(props) => props.topOffset};
  max-height: 300px;
  overflow-y: scroll;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 16px;
  border: 1px solid #d2d2d2;
`;
